import { useState, useEffect, useContext } from 'react'
import { DeleteModalContext, ThemeContext } from '../../layout/BaseLayout';
import * as PackageMasterServices from '../../services/packageMasterServices';
import { Loader } from '../../utils/loader';
import NoDataError from '../../components/NoDataError';
import { hanldeSortingArray } from '../../utils/sortingByColumn';
import { Button, Modal, ModalDialog } from 'react-bootstrap';
import Draggable from 'react-draggable';
import { Editor } from 'react-draft-wysiwyg';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { ContentState, EditorState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';

const packageMasterModalDragModal = (props) => {
	return (
		<Draggable handle=".modal-header">
			<ModalDialog {...props} />
		</Draggable>
	);
};

const PackageMaster = () => {

	let toast = useContext(ThemeContext);
	let deleteData = useContext(DeleteModalContext);

	const defaultObj = {
		"packageId": "",
		"vendorId": "",
		"packageImage": "",
		"packageShortDesc": "",
		"packageLongDesc": "",
		"packageIsPopular": true,
		"packageStatus": true,
		"packageName": "",
		"packagePlans": [{
			"packagePlanId": "",
			"packagePlanType": "Monthly",
			"packagePlanPrice": "",
			"packagePlanCurrency": "",
			"packagePlanNoOfRequest": "",
			"packagePlanDescription": "",
			"packagePlanActive": true,
		}]
	}

	const defaultErrorObj = {
		packageNameError: false,
		shortDesError: false,
		longDesError: false,
		priceError: false,
		requestError: false,
		currencyError: false,
		descriptionPlanError: false,
	}

	const defaultSortingOrderObj = {
		sortingOrder: 'asc',
		upDownArrowColumn: null,
		fieldType: null,
	}

	const [packageMasterObj, setPackageMasterObj] = useState({ ...defaultObj });
	const [packageMasterList, setPackageMasterList] = useState([]);
	const [packagePlansList, setPackagePlansList] = useState([]);
	const [showPackageModal, setShowPackageModal] = useState(false);
	const [isLoader, setIsLoader] = useState(false);
	const [selectedArr, setSelectedArr] = useState([]);
	const [disableAddBtn, setDisableAddBtn] = useState(false);
	const [errors, setErrors] = useState(defaultErrorObj);
	const [sortingOrderObj, setSortingOrderObj] = useState({ ...defaultSortingOrderObj })
	const [popupActiveTab, setPopupActiveTab] = useState(1);
	const [plansListEdit, setPlansListEdit] = useState(false);
	const [editorState, setEditorState] = useState(EditorState.createEmpty());

	const onOpenPackageMasterModal = () => {
		setShowPackageModal(true);
		setPackageMasterObj({ ...defaultObj });
		setErrors({ ...defaultErrorObj });
		setPopupActiveTab(1);
	}

	const onClosePackageMasterModal = () => {
		setShowPackageModal(false);
		setPackageMasterObj({ ...defaultObj });
		setErrors({ ...defaultErrorObj });
		setPopupActiveTab(1);
	}

	const getPackages = () => {
		setIsLoader(true);
		PackageMasterServices.getAllPackages().then((res) => {
			setIsLoader(false);
			if (res.isSuccess) {
				setPackageMasterList(res.data);
			} else {
				setIsLoader(false);
			}
		}).catch(e => {
			setIsLoader(false);
		})
	}

	const onEditPackageData = (id) => {
		PackageMasterServices.getPackagesById(id).then((res) => {
			if (res.isSuccess) {
				let text = res.data?.packageLongDesc;
				const contentBlock = htmlToDraft(text);
				if (contentBlock) {
					const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
					setEditorState(EditorState.createWithContent(contentState));
					setPackageMasterObj(res.data);
					setPackagePlansList(res.data);
				} else {
					setPackageMasterObj(res.data);
					setPackagePlansList(res.data);
				}
				setShowPackageModal(true);
			} else {
				toast.error(res?.exception?.message);
			}
		})
	}

	const onImageChoose = (fld, event) => {
		if (event.target.files[0]?.size < 51200) {
			let file = event.target.files[0];
			let name = event.target.name
			let value = event.target.value;

			if (["jpg", "jpeg", "png", "gif"].includes(value.split(".")[value.split(".").length - 1])) {

				let reader = new FileReader();

				reader.onloadend = () => {
					let updatedta = { ...packageMasterObj }
					updatedta[fld] = reader.result
					setPackageMasterObj({ ...updatedta })
				}
				reader.readAsDataURL(file);

			} else {
				toast.error("Only Image file formats - jpg, jpeg, png, gif supported !!!")
				document.getElementById("packageImage").value = ""
			}

		} else {
			toast.error("Logo Size must be lower than 50 KB !!!")
			document.getElementById("packageImage").value = ""
		}
	}

	const onSelectionRow = (item) => {
		if (!!packageMasterList && packageMasterList.length > 0) {
			const selectedRow = packageMasterList.map((elem) => { return elem.packageId }).indexOf(item.packageId);
			if (selectedRow > -1) {
				setSelectedArr([packageMasterList[selectedRow]]);
			}
		}
	}

	const checkItem = (item) => {
		const checkData = !!selectedArr && selectedArr.some((val) => val?.packageId === item?.packageId);
		return checkData;
	}

	const creatingSortingArrFn = (field, type) => {
		let order = sortingOrderObj.sortingOrder;
		if (field === sortingOrderObj.upDownArrowColumn) {
			order = order === 'asc' ? 'desc' : 'asc';
			setSelectedArr([]);
		} else {
			order = 'asc';
			setSelectedArr([]);
		}
		setSortingOrderObj({ sortingOrder: order, upDownArrowColumn: field, fieldType: type })
	}


	useEffect(() => {
		if (!!sortingOrderObj && sortingOrderObj.upDownArrowColumn !== '') {
			let sortedArrayByColumn = [...packageMasterList]
			sortedArrayByColumn = hanldeSortingArray(sortedArrayByColumn, sortingOrderObj.upDownArrowColumn, sortingOrderObj.fieldType, sortingOrderObj.sortingOrder)
			setPackageMasterList(sortedArrayByColumn);
		}
	}, [sortingOrderObj])

	useEffect(() => {
		getPackages();
	}, [])

	return (
		<>
			<div id='tabs'>
				{(!!isLoader && isLoader) && <Loader />}
				<div className="maintitle-box">
					<div className="w-50 d-inline-block">
						<h2 className="maintitle "><img className="main-title-img" src={"/images/svg/package-master.svg"} alt="" />Package Master</h2>
					</div>
					<div className="w-50 d-inline-block">
						<div className="float-end ">
							<div className="d-inline-block mr-3"><i id="feedModuleRefresh" className="fa fa-refresh font-size-14 remove_arrow_summary mt-2"
								onClick={() => {
									getPackages();
								}}></i>
							</div>
							{/* <button className="addnewbtn mb-0" onClick={() => { onOpenPackageMasterModal() }}>
								<i className="fa-solid fa-circle-plus mr-2"></i>Add
							</button> */}
						</div>
					</div>
				</div>
				<div className="thead-fixed">
					<table className="table table-bordered table-strip w-100 mb-30 new-data-asc-desc">
						<thead>
							<tr className="thead-dard-bg">
								<th className=" srn-width">Sr</th>
								<th className={`sorting sorting_${sortingOrderObj.upDownArrowColumn === 'packageName' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('packageName', 'Text')}>Name</th>
								<th className={`sorting sorting_${sortingOrderObj.upDownArrowColumn === 'packageIsPopular' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('packageIsPopular', 'Status')}>Is Popular</th>
								<th className={`sorting sorting_${sortingOrderObj.upDownArrowColumn === 'packageStatus' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('packageStatus', 'Status')}>Status </th>
								{/* <th>Action</th> */}
							</tr>
						</thead>
						<tbody>
							{(!!packageMasterList && packageMasterList.length > 0) ? packageMasterList.map((item, i) => {
								return (
									<tr key={i} onDoubleClick={() => { onEditPackageData(item.packageId) }} onClick={() => onSelectionRow(item)}
										className={`${!item?.packageStatus && 'gray-text'} ${checkItem(item) ? 'selected-tr' : ''} `}>
										<td className="">{i + 1}</td>
										<td className="">{item.packageName}</td>
										<td className="">{item.packageIsPopular ? "Yes" : "No"}</td>
										<td className="">{item.packageStatus ? "Active" : "InActive"}</td>
									</tr>
								)
							}) : <NoDataError colspn={7} />}
						</tbody>
					</table>
				</div>
			</div>
			<div className="login-popup">
				<Modal
					className="login licence-modules package-master"
					show={showPackageModal}
					onHide={() => onClosePackageMasterModal()}
					backdrop="static"
					dialogAs={packageMasterModalDragModal}
					animation={false}
					size="md"
					centered
				>
					<Modal.Header closeButton style={{ border: "none" }}>
						<Modal.Title className="w-100">
							Package Master
							<div className="btn-help d-inline-block float-right">

							</div>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body style={{ display: "flex", flexDirection: "column" }}>
						<div className="p-1">
							<div className="feederbox">
								<div className="container p-0">
									<ul className="nav nav-tabs">
										<li className="nav-item">
											<a
												className={
													popupActiveTab === 1 ? "nav-link active" : "nav-link"
												}
												onClick={() => {
													setPopupActiveTab(1);
												}}
											>
												Packages
											</a>
										</li>
										<li className="nav-item">
											<a
												className={
													popupActiveTab === 2 ? "nav-link active" : "nav-link"
												}
												onClick={() => {
													setPopupActiveTab(2);
												}}
											>
												Plans
											</a>
										</li>
									</ul>
									{popupActiveTab === 1 &&

										<div className="fidderbox-inner office-height-modulemaster ">
											<div className="prl">
												<table border="0" cellSpacing="0" cellPadding="0" className="w-100 font11 mt-0">
													<tr>
														<td className="licence150  symbolrw-24 text-right font11">Vendor :</td>
														<td className="licence200 d-inline-block symbolrw-25">
															<input
																type="text"
																className="inputborder font11 w-100 ml-2 h20 "
																maxLength={100}
																name="vendorId"
																value={packageMasterObj.vendorId}
																autoComplete="off"
															/>
														</td>
														<td className="licence50" >&nbsp;</td>
														<td className="symbolrw-24 text-right font11 licence150">Package Name :</td>
														<td className={`licence200`}>
															<input
																type="text"
																className="inputborder font11 w-100 ml-2 h20" name="feedModuleDisplayName"
																value={packageMasterObj.packageName}
																autoComplete="off"
																maxLength={200}
																autoFocus
															/>
														</td>
													</tr>
													<tr>
														<td className="licence150  symbolrw-24 text-right font11">
															<div className="imgpreview">
																<img alt="" src={packageMasterObj?.packageImage} />
															</div>
														</td>
														<td className="form-group d-inline-block ml-2 mt-2">
															<label className="licence150  symbolrw-24  font11 mb-0">Package Image :</label>
															<input
																type="file"
																className="form-control h20 lh10"
																id="packageImage"
																onChange={(e) => { onImageChoose("packageImage", e) }}
																accept="image/*"
															/>
														</td>
														<td className="licence50" >&nbsp;</td>
														<td className="licence150  symbolrw-24 text-right font11">Short Description :</td>
														<td className="licence200 d-inline-block symbolrw-25">
															<input
																type="text"
																className="inputborder font11 w-100 ml-2 h20 "
																maxLength={100}
																value={packageMasterObj.packageShortDesc}
																autoComplete="off"
															/>
														</td>
													</tr>
													<tr>
														<td className="symbolrw-24 text-right font11 licence150">Status :</td>
														<td className={`licence200 d-inline-block symbolrw-25`}>
															<div className="d-inline-block">
																<div className="form-check-inline mt-1 mr-4 width-25">
																	<label className="form-check-label marginleft25group">
																		<input
																			type="radio"
																			className="form-check-input mt-1"
																			name="packageStatus"
																			checked={packageMasterObj?.packageStatus} />Yes
																	</label>
																</div>
																<div className="form-check-inline width-25">
																	<label className="form-check-label ml-3">
																		<input
																			type="radio"
																			className="form-check-input mt-1"
																			name="packageStatus"
																			checked={!packageMasterObj?.packageStatus} />No
																	</label>
																</div>
															</div>
														</td>
														<td className="licence50" >&nbsp;</td>
														<td className="licence150  symbolrw-24 text-right font11">Package Is Popular :</td>
														<td className={`licence200 d-inline-block symbolrw-25`}>
															<div className="d-inline-block">
																<div className="form-check-inline mr-4 width-25">
																	<label className="form-check-label marginleft25group">
																		<input
																			type="radio"
																			className="form-check-input mt-1"
																			name="packageIsPopular"
																			checked={packageMasterObj?.packageIsPopular} />Yes
																	</label>
																</div>
																<div className="form-check-inline width-25">
																	<label className="form-check-label ml-3">
																		<input
																			type="radio"
																			className="form-check-input mt-1"
																			name="packageIsPopular"
																			checked={!packageMasterObj?.packageIsPopular} />No
																	</label>
																</div>
															</div>
														</td>
													</tr>
													<tr>
														<td colSpan={5} className='h20'></td>
													</tr>
													<tr>
														<td className="symbolrw-24 text-right font11 licence150 align-baseline">Long Description :</td>
														<td colSpan={4} className={``}>
															<Editor
																editorState={editorState}
																// onEditorStateChange={handleEditorChange}
																toolbarClassName="toolbarClassName"
																wrapperClassName="wrapperClassName wrap121212"
																editorClassName="editorClassName"
																toolbar={{
																	options: ['inline', 'fontSize', 'colorPicker', 'emoji', 'history'],
																}}
															/>
														</td>
													</tr>
												</table>
											</div>
										</div>}

									{popupActiveTab === 2 &&
										<>
											<div className="fidderbox-inner office-height-modulemaster-plan ">
												<div className='prl'>
													<table border="0" cellSpacing="0" cellPadding="0" className="w-100 font11 mt-0">
														<tr>
															<td className="symbolrw-24 text-right font11 licence150">Time Period :</td>
															<td className={`licence200`}>
																<select
																	className="form-select inputborder w-100 ml-2 font11 h20 mb-2"
																	name="packagePlanType"
																	value={packageMasterObj?.packagePlans.packagePlanType}
																>
																	<option value="Monthly">Monthly</option>
																	<option value="Quarterly">Quarterly</option>
																	<option value="HalfYearly">HalfYearly</option>
																	<option value="Yearly">Yearly</option>
																</select>
															</td>
															<td className="licence50" >&nbsp;</td>
															<td className="licence150  symbolrw-24 text-right font11">Price :</td>
															<td className={`licence200 d-inline-block symbolrw-25 ${errors.priceError ? 'error' : ''}`}>
																<input
																	type="number"
																	className="inputborder font11 w-100 ml-2 h20 mb-2"
																	maxLength={100}
																	value={packageMasterObj?.packagePlans?.packagePlanPrice}
																/>
															</td>
														</tr>
														<tr>
															<td className="symbolrw-24 text-right font11 licence150">Currency :</td>
															<td className={`licence200 ${errors?.currencyError ? 'error' : ''}`}>
																<input
																	type="text"
																	className="inputborder font11 w-100 ml-2 h20 mb-2"
																	maxLength={100}
																	value={packageMasterObj?.packagePlans?.packagePlanCurrency}
																/>
															</td>
															<td className="licence50" >&nbsp;</td>
															<td className="licence150  symbolrw-24 text-right font11">Request :</td>
															<td className={`licence200 d-inline-block symbolrw-25 ${errors.requestError ? 'error' : ''}`}>
																<input
																	type="text"
																	className="inputborder font11 w-100 ml-2 h20 mb-2"
																	maxLength={100}
																	value={packageMasterObj?.packagePlans?.packagePlanNoOfRequest}
																/>
															</td>
														</tr>
														<tr>
															<td className="symbolrw-24 text-right font11 licence150">Description :</td>
															<td className={`licence200 ${errors.descriptionPlanError ? 'error' : ''}`}>
																<input
																	type="text"
																	className="inputborder font11 w-100 ml-2 h20 mb-2"
																	maxLength={100}
																	value={packageMasterObj?.packagePlans?.packagePlanDescription}
																/>
															</td>
															<td className="licence50" >&nbsp;</td>
															<td className="licence150  symbolrw-24 text-right font11">Active :</td>
															<td className="licence200 d-inline-block symbolrw-25">
																<input
																	className="form-check-input ml-2 mt-2"
																	type="checkbox"
																	id={"chkActiveStatus"}
																	name={"chkActiveStatus"}
																	checked={packageMasterObj?.packagePlans?.packagePlanActive}
																/>
															</td>
														</tr>
														<tr>
															<td colSpan={5}>&nbsp;</td>
														</tr>
														<tr>
															<td colSpan={4}>&nbsp;</td>
															{/* <td >
																<button className="btnmain mr-3" onClick={() => { onAddPlans() }} disabled={disableAddBtn}>
																	{disableAddBtn && <i className="fa fa-spinner fa-spin mr-2"></i>}Add
																</button>
															</td> */}
														</tr>
													</table>
												</div>
												<div className="thead-fixed plan-table-height">
													<table className="table table-bordered table-strip w-100 mb-30 new-data-asc-desc ">
														<thead>
															<tr className="thead-dard-bg">
																<th className=" srn-width">Sr</th>
																<th>Time Period</th>
																<th>Price </th>
																<th>Currency </th>
																<th>Request </th>
																<th>Description </th>
																<th>Active </th>
															</tr>
														</thead>
														<tbody className=''>
															{(!!packagePlansList?.packagePlans && packagePlansList?.packagePlans?.length > 0) ? packagePlansList?.packagePlans?.map((item, index) => {
																return (
																	<tr className={`${!item?.packagePlanActive && 'gray-text'}`} key={`${index}`}>
																		<td>{index + 1}</td>
																		<td>{item?.packagePlanType}</td>
																		<td>{item?.packagePlanPrice}</td>
																		<td>{item?.packagePlanCurrency}</td>
																		<td>{item?.packagePlanNoOfRequest}</td>
																		<td>{item?.packagePlanDescription}</td>
																		<td>{item?.packagePlanActive ? "Active" : "InActive"}</td>
																	</tr>
																)
															}) : <NoDataError colspn={8} />}
														</tbody>
													</table>
												</div>
											</div>
										</>
									}
								</div>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<div>
							<div className="w-100 text-right p-1">
								<Button onClick={() => onClosePackageMasterModal()} className="btnmain-danger">
									Cancel
								</Button>
							</div>
						</div>
					</Modal.Footer>
				</Modal>
			</div>
		</>
	)
}

export default PackageMaster